/**
 * Console display for use in the Iris environment.
 */
import React, { memo, useMemo } from 'react';
import { Button, CopyButton, ContextualHelp } from '@deephaven/components';
import "./ConsoleHistoryItem.css";
import { vsDebugRerun } from '@deephaven/icons';
import classNames from 'classnames';
import ConsoleHistoryItemTooltip from "./ConsoleHistoryItemTooltip.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Get the action bar class for a console history item.
 * @param lineCount The number of lines in the console history item.
 * @returns The action bar class name or null if not applicable.
 */
var getActionBarClass = item => {
  if ((item === null || item === void 0 ? void 0 : item.command) == null) {
    return null;
  }
  var lineCount = item.command ? item.command.split('\n').length : 0;
  if (lineCount > 2) {
    return null;
  }
  return "console-history-actions-".concat(lineCount);
};
var ConsoleHistoryItemActions = /*#__PURE__*/memo(props => {
  var item = props.item,
    onCommandSubmit = props.onCommandSubmit,
    handleTooltipVisible = props.handleTooltipVisible;
  var actionBarClass = useMemo(() => getActionBarClass(item), [item]);
  return /*#__PURE__*/_jsxs("div", {
    className: classNames('console-history-actions', actionBarClass),
    children: [item.command != null && /*#__PURE__*/_jsx(CopyButton, {
      copy: item.command
    }), /*#__PURE__*/_jsx(Button, {
      icon: vsDebugRerun,
      kind: "inline",
      onClick: () => {
        var _item$command;
        return onCommandSubmit((_item$command = item.command) !== null && _item$command !== void 0 ? _item$command : '');
      },
      tooltip: "Rerun",
      children: null
    }), /*#__PURE__*/_jsx(ContextualHelp, {
      variant: "info",
      onOpenChange: handleTooltipVisible,
      UNSAFE_className: "console-history-item-contextual-help",
      children: /*#__PURE__*/_jsx(ConsoleHistoryItemTooltip, {
        item: item
      })
    })]
  });
});
ConsoleHistoryItemActions.displayName = 'ConsoleHistoryItemActions';
export default ConsoleHistoryItemActions;
//# sourceMappingURL=ConsoleHistoryItemActions.js.map